import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { fmtNum, uuid } from "@/lib/format";
import { live, SERVICE_CATS } from "@/lib/clinic";
import { BigButton, Chip, Field, inputCls } from "@/components/ui-kit";

export default function ServicesTab() {
  const { t, view, dispatch, can, money } = useApp();
  const [f, setF] = useState({ name: "", price: "", category: "consultation", duration: "" });
  const services = live(view.services);
  const save = () => {
    if (!f.name.trim() || f.price === "") return toast.error(t("name_price_required"));
    if (dispatch("service.upsert", { id: uuid(), name: f.name.trim(), price: Number(f.price), category: f.category, duration: Number(f.duration || 0) })) { toast.success(t("saved")); setF({ ...f, name: "", price: "" }); }
  };
  return (
    <div className="space-y-3" data-testid="services-tab">
      {can("inventory") && (
        <div className="rounded border border-[#CCCCCC] bg-[#F7F7F7] p-3 space-y-2">
          <div className="flex flex-wrap gap-1.5">{SERVICE_CATS.map((c) => <Chip key={c} active={f.category === c} onClick={() => setF({ ...f, category: c })} data-testid={`svc-cat-${c}`}>{t(`svc_${c}`)}</Chip>)}</div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
            <Field label={t("name")}><input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inputCls} data-testid="svc-name-input" /></Field>
            <Field label={t("price")}><input dir="ltr" inputMode="decimal" value={f.price} onChange={(e) => setF({ ...f, price: e.target.value })} className={inputCls} data-testid="svc-price-input" /></Field>
            <Field label={`${t("duration")} (min)`}><input dir="ltr" inputMode="numeric" value={f.duration} onChange={(e) => setF({ ...f, duration: e.target.value })} className={inputCls} data-testid="svc-duration-input" /></Field>
            <div className="flex items-end"><BigButton onClick={save} className="w-full !h-12" data-testid="svc-save-btn"><Plus className="w-5 h-5" />{t("add")}</BigButton></div>
          </div>
        </div>
      )}
      <div className="rounded border border-[#CCCCCC] bg-white overflow-hidden">
        <table className="w-full text-sm" data-testid="services-table">
          <thead><tr className="bg-[#E8E8E8] text-xs"><th className="text-start py-2 px-3">{t("name")}</th><th className="text-start px-3">{t("category")}</th><th className="text-end px-3">{t("price")}</th><th className="text-end px-3">{t("duration")}</th><th /></tr></thead>
          <tbody>
            {services.map((s) => (
              <tr key={s.id} className="border-t border-[#E5E5E5]" data-testid="service-row">
                <td className="py-2 px-3 font-bold">{s.name}</td><td className="px-3">{t(`svc_${s.category}`)}</td><td className="px-3 text-end" dir="ltr">{money(s.price)}</td><td className="px-3 text-end" dir="ltr">{s.duration ? `${fmtNum(s.duration)} min` : "—"}</td>
                <td className="px-2 text-end">{can("inventory") && <button type="button" onClick={() => window.confirm(t("confirm_delete")) && dispatch("service.delete", { id: s.id, name: s.name })} className="text-[#C7353B] w-8 h-8 grid place-items-center" data-testid={`svc-delete-${s.id}`}><Trash2 className="w-4 h-4" /></button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!services.length && <p className="p-4 text-sm text-muted-foreground">{t("services_empty")}</p>}
      </div>
    </div>
  );
}
